import angular from 'angular';
import timesheetDetailComponent from "./timesheet-detail.component";

let reviewTimeSheetDetailModule = angular.module('reviewTimesheetDetail', [
  'ui.router'
])
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state('reviewTimesheetDetail', {
      url: "/review/timesheet/:timesheetId",
      // This must match the name in first param or controller will not be called?
      template: '<review-timesheet-detail></review-timesheet-detail>',
      data: {
        pageHeader: true,
        pageTitle: "Timesheet Review Details",
        pageDesc: "Review an individual users timesheet.",
        breadcrumbLink: 'review',
        breadcrumbText: 'Review/Approve User Timesheets'
      }
    })
  })
  .component("reviewTimesheetDetail", timesheetDetailComponent);

export default reviewTimeSheetDetailModule;



// WEBPACK FOOTER //
// ./client/pages/review/modals/timesheet-detail/timesheet-detail.js